import { useEffect } from "react";

interface RouteScrollResetOptions {
  pathname: string;
  search: string;
  hash: string;
}

export function useRouteScrollReset({ pathname, search, hash }: RouteScrollResetOptions) {
  useEffect(() => {
    if (hash) {
      const rawId = hash.slice(1);
      const id = (() => {
        try {
          return decodeURIComponent(rawId);
        } catch {
          return rawId;
        }
      })();

      requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({ block: "start" });
      });
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search, hash]);
}
